enum CountdownTimerSize {
  SMALL = 'small',
  NORMAL = 'normal',
}

export default CountdownTimerSize;
